import { render, staticRenderFns } from "./SyncOpportunityDialog.vue?vue&type=template&id=53970569"
import script from "./SyncOpportunityDialog.vue?vue&type=script&lang=js"
export * from "./SyncOpportunityDialog.vue?vue&type=script&lang=js"
import style0 from "./SyncOpportunityDialog.vue?vue&type=style&index=0&id=53970569&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports